export default __webpack_public_path__ + "static/media/feature-b-2.dc750dc5.jpg";